import { Panel } from "@/components/common";

const RULES = [
  ["Daily levels", "Each trading day the engine publishes a fresh set of levels for every market once it has the price data it needs. Until then the market shows Pending."],
  ["Market states", "Pending means levels are not ready. Waiting means the engine is watching for an entry. In trade and In reversal show an open position. Done and Skipped mean that market has finished for the day."],
  ["Trading hours", "Each market only trades inside its own session window, shown in London time on the board. Open positions are managed automatically until they close."],
  ["Paper and live", "Every trade is recorded on the paper account first. Live orders are only sent to MT5 when an admin has armed live trading and the market is set to live mirror."],
  ["Safety", "The kill switch watches account equity while live trading is armed. If losses pass the set limit, every live position is closed and trading is disarmed. KILL does this straight away."],
  ["Your controls", "Use the auto-trade switch to pause new entries, Settings to adjust each market, and Close on any active trade to exit it by hand."],
];

export function HowItWorks() {
  return (
    <Panel title="How it works" testid="levels-how-it-works">
      <div className="grid gap-x-10 gap-y-5 md:grid-cols-2">
        {RULES.map(([h, t]) => (
          <div key={h}>
            <h3 className="font-display text-sm font-semibold text-slate-200">{h}</h3>
            <p className="mt-1 text-sm leading-relaxed text-slate-400">{t}</p>
          </div>
        ))}
      </div>
    </Panel>
  );
}
